import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/Home.vue'),
      meta: {
        requiresAuth: false,
        invalid_domains: []
      }
    },
    {
      path: '/translate',
      name: 'translate',
      component: () => import('../views/Translate.vue'),
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/train',
      name: 'train',
      component: () => import('../views/Train.vue'),
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/similarity',
      name: 'similarity',
      component: () => import('../views/Similarity.vue'),
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/editor',
      name: 'editor_open',
      component: () => import('../views/EditorOpen.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/editor/:mode/:xid',
      name: 'editor',
      component: () => import('../views/Editor.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('../views/UserDetail.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/file',
      name: 'file',
      component: () => import('../views/File.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/file/upload',
      name: 'file_upload',
      component: () => import('../views/FileUpload.vue'),
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/file/:fid',
      name: 'file_detail',
      component: () => import('../views/FileDetail.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/job',
      name: 'job',
      component: () => import('../views/Job.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/job/:jid',
      name: 'job_detail',
      component: () => import('../views/JobDetail.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/model',
      name: 'model',
      component: () => import('../views/Model.vue'),
      props: {
        mode: "user",
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/model/:mid',
      name: 'model_detail',
      component: () => import('../views/ModelDetail.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/corpus',
      name: 'corpus',
      component: () => import('../views/Corpus.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/corpus/import',
      name: 'corpus_import',
      component: () => import('../views/CorpusImport.vue'),
      props: {
        corpus_types: ['new_corpus', 'translated']
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/corpus/:cid',
      name: 'corpus_detail',
      component: () => import('../views/CorpusDetail.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/corpus/:cid/import',
      name: 'corpus_import_target',
      component: () => import('../views/CorpusImport.vue'),
      props: {
        mode: "user",
        corpus_types: ['new_corpus', 'uploaded_corpus', 'translated']
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/term',
      name: 'term',
      component: () => import('../views/Term.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/term/import',
      name: 'term_import',
      component: () => import('../views/TermImport.vue'),
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/term/:yid',
      name: 'term_detail',
      component: () => import('../views/TermDetail.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/translation_preset',
      name: 'translation_preset',
      component: () => import('../views/TranslationPreset.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/translation_preset/regist',
      name: 'translation_preset_regist',
      component: () => import('../views/TranslationPresetRegist.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/translation_preset/:tid',
      name: 'translation_preset_detail',
      component: () => import('../views/TranslationPresetDetail.vue'),
      props: {
        mode: "user"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/group',
      name: 'group_group',
      component: () => import('../views/GroupDetail.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/user',
      name: 'group_user',
      component: () => import('../views/User.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/user/regist',
      name: 'group_user_regist',
      component: () => import('../views/UserRegist.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/user/batch',
      name: 'group_user_batch',
      component: () => import('../views/UserBatch.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/user/:uid',
      name: 'group_user_detail',
      component: () => import('../views/UserDetail.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/file',
      name: 'group_file',
      component: () => import('../views/File.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/file/:fid',
      name: 'group_file_detail',
      component: () => import('../views/FileDetail.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/job',
      name: 'group_job',
      component: () => import('../views/Job.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/job/:jid',
      name: 'group_job_detail',
      component: () => import('../views/JobDetail.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/model',
      name: 'group_model',
      component: () => import('../views/Model.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/group/model/:mid',
      name: 'group_model_detail',
      component: () => import('../views/ModelDetail.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/group/corpus',
      name: 'group_corpus',
      component: () => import('../views/Corpus.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/group/corpus/:cid',
      name: 'group_corpus_detail',
      component: () => import('../views/CorpusDetail.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/group/term',
      name: 'group_term',
      component: () => import('../views/Term.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/group/term/:yid',
      name: 'group_term_detail',
      component: () => import('../views/TermDetail.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/group/translation_preset',
      name: 'group_translation_preset',
      component: () => import('../views/TranslationPreset.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/group/translation_preset/:tid',
      name: 'group_translation_preset_detail',
      component: () => import('../views/TranslationPresetDetail.vue'),
      props: {
        mode: "group"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/organization',
      name: 'organization_organization',
      component: () => import('../views/OrganizationDetail.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    /*{
      path: '/organization/organization/web_socket',
      name: 'organization_organization_websocket',
      component: () => import('../views/WebSocketList.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },*/
    {
      path: '/organization/group',
      name: 'organization_group',
      component: () => import('../views/Group.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/group/regist',
      name: 'organization_group_regist',
      component: () => import('../views/GroupRegist.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/group/:gid',
      name: 'organization_group_detail',
      component: () => import('../views/GroupDetail.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/user',
      name: 'organization_user',
      component: () => import('../views/User.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/user/regist',
      name: 'organization_user_regist',
      component: () => import('../views/UserRegist.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/user/batch',
      name: 'organization_user_batch',
      component: () => import('../views/UserBatch.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/user/:uid',
      name: 'organization_user_detail',
      component: () => import('../views/UserDetail.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    /*{
      path: '/organization/user/:uid/web_socket',
      name: 'organization_user_websocket',
      component: () => import('../views/WebSocketList.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },*/
    {
      path: '/organization/file',
      name: 'organization_file',
      component: () => import('../views/File.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/file/:fid',
      name: 'organization_file_detail',
      component: () => import('../views/FileDetail.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/job',
      name: 'organization_job',
      component: () => import('../views/Job.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/job/:jid',
      name: 'organization_job_detail',
      component: () => import('../views/JobDetail.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/model',
      name: 'organization_model',
      component: () => import('../views/Model.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/organization/model/:mid',
      name: 'organization_model_detail',
      component: () => import('../views/ModelDetail.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/organization/corpus',
      name: 'organization_corpus',
      component: () => import('../views/Corpus.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/organization/corpus/:cid',
      name: 'organization_corpus_detail',
      component: () => import('../views/CorpusDetail.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/organization/term',
      name: 'organization_term',
      component: () => import('../views/Term.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/organization/term/:yid',
      name: 'organization_term_detail',
      component: () => import('../views/TermDetail.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: ['the-reading']
      }
    },
    {
      path: '/organization/translation_preset',
      name: 'organization_translation_preset',
      component: () => import('../views/TranslationPreset.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/organization/translation_preset/:tid',
      name: 'organization_translation_preset_detail',
      component: () => import('../views/TranslationPresetDetail.vue'),
      props: {
        mode: "organization"
      },
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../views/Profile.vue'),
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/version',
      name: 'version',
      component: () => import('../views/Version.vue'),
      meta: {
        requiresAuth: false,
        invalid_domains: []
      }
    },
    {
      path: '/preference',
      name: 'preference',
      component: () => import('../views/Preference.vue'),
      meta: {
        requiresAuth: true,
        invalid_domains: []
      }
    },
    {
      path: '/auth/callback',
      name: 'auth_callback',
      component: () => import('../views/AuthCallback.vue'),
      meta: {
        requiresAuth: false,
        invalid_domains: []
      }
    }
  ]
})
